<template>
    <div>
        <Language v-model="form.lang" @change="handleLangChange"></Language>
        <div class="e-title">基础介绍</div>
        <el-form size="mini" label-width="100px">
            <el-form-item label="排序">{{ form.sort }}</el-form-item>
            <el-form-item label="分类">{{ form.category.name }}</el-form-item>
            <el-form-item label="标题"
                >{{ form.name }}
                <span v-if="form.video_uuid" style="margin-left: 100px">seo关键词: {{ form.video.keyword }}</span>
            </el-form-item>
            <el-form-item label="封面图"><img style="height: 80px" :src="ossUrl + form.cover" /></el-form-item>
            <el-form-item label="功能介绍">{{ form.info }}</el-form-item>
            <el-form-item label="关联案例">
                <el-table :data="form.mcase">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="案例标题" prop="name"></el-table-column>
                    <el-table-column label="分类" prop="category.name"></el-table-column>
                    <el-table-column label="创建时间" prop="create_time"></el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="产品列表">
                <el-table :data="form.goods">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="商品标题" prop="name"></el-table-column>
                    <el-table-column label="分类" prop="category.name"></el-table-column>
                    <el-table-column label="创建时间" prop="create_time"></el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="关联文件">
                <el-table :data="form.file">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="文件标题" prop="name"></el-table-column>
                    <el-table-column label="分类" prop="mgroup.name"></el-table-column>
                    <el-table-column label="创建时间" prop="create_time"></el-table-column>
                    <el-table-column label="下载人群" prop="label.name"></el-table-column>
                </el-table>
            </el-form-item>
            <div class="e-title">适用场景</div>
            <el-form-item label="">
                <div v-if="form.type == 1" v-html="form.detail"></div>
                <video controls v-else :src="ossUrl + form.video.url"></video>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import { detail } from "@/api/plan/list";
import { ossUrl } from "@/configs/oss";
export default {
    components: { Language },
    data() {
        return {
            ossUrl,
            form: {
                lang: "zh",
                category: {},
                video: {},
            },
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        this.getDetail();
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result, video: result.video ? result.video : {}, category: result.category ? result.category : {} };
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid, category: {}, video: {} };
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
